import React, { useState } from 'react';
import { generateChildrenFromList } from 'cms/parsers';
import { Body, Box, Button, H4, H6, red } from 'dma-ui-kit';
import styled from 'styled-components';

const Container = styled(Box)`
  padding: 0 12px;
  @media (min-width: 1025px) {
      padding: 0 48px;
  }
  @media (max-width: 1024px) {
      padding: 0 24px;
  }

  max-width: 1250px;
  margin-bottom: 20px;
  & h2 {
    margin: 5px 0;
  }
  & h5 {
    margin: 5px 0;
  }
`;

const SecuredContent = props => {
    const { paragraph } = props;

    const title = paragraph.attributes.field_title;
    const description = paragraph.attributes.field_description;
    const password = paragraph.attributes.field_password;
    const children = generateChildrenFromList(paragraph.relationships?.field_secured_content?.data || []);

    
    const [enteredPassword, setEnteredPassword] = useState('');
    const [isUnlocked, setIsUnlocked] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = event => {
        event.preventDefault();

        if (enteredPassword === password) {
            setIsUnlocked(true);
            setError('');
        } else {
            setIsUnlocked(false);
            setError('invalid password');
        }
    };

    const renderText = value => {
        if (!value) return null;
        if (typeof value === 'string') return value;
        if (value.processed) {
            return <span dangerouslySetInnerHTML={{ __html: value.processed }} />;
        }
        if (value.value) return value.value;
        return null;
    };

    const titleContent = renderText(title);
    const descriptionContent = renderText(description);

    return (
        <Container>
            {isUnlocked ? (
                <>{children}</>
            ) : (
                <>
                    {titleContent && <H4>{titleContent}</H4>}
                    {descriptionContent && <H6>{descriptionContent}</H6>}
                    <PasswordForm onSubmit={handleSubmit}>
                        <PasswordInput
                            type="password"
                            value={enteredPassword}
                            placeholder="Enter password"
                            onChange={event => {
                                setEnteredPassword(event.target.value);
                                if (error) {
                                    setError('');
                                }
                            }}
                            aria-label="Password"
                        />
                        <Button type="submit" variant="tertiary" label="Submit" />
                        {error && <ErrorText>{error}</ErrorText>}
                    </PasswordForm>
                </>
            )}
        </Container>
    );
};

const PasswordForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 360px;
`;

const PasswordInput = styled.input`
    padding: 10px 12px;
    border-radius: 4px;
    border: 1px solid #c9c9c9;
    font-size: 16px;
`;

const ErrorText = styled(Body)`
    color: ${red};
`;

export default SecuredContent;